export default __webpack_public_path__ + "static/media/calendar.7d0fa8c0.svg";